import * as Yup from "yup";

export const FormContactScheme = (messages) => {
  return Yup.object().shape({
    name: Yup.string().required(messages.nameRequired),
    email: Yup.string().email(messages.emailInvalid).required(messages.emailRequired),
    message: Yup.string().min(10, messages.messageMin).required(messages.messageRequired),
  });
};
